// extracted by mini-css-extract-plugin
export default {"cls1":"VeloMenu-Menu_cls1__cKQH+","cls2":"VeloMenu-Menu_cls2__4YgCJ VeloMenu-Menu_cls1__cKQH+"};